import PropTypes from 'prop-types';
import React from 'react';
import Icon, { GLYPHS } from '../../../common/icon';

const BarberAvatar = ({ barber }) => {
  const { photos } = barber;

  if (photos && photos.length) {
    return (<img className="c-avatar-image" src={photos[0].thumbnail} alt="" />);
  }

  return (<Icon glyph={GLYPHS.customers} size="medium" />);
};

BarberAvatar.propTypes = {
  barber: PropTypes.object,
};

BarberAvatar.defaultProps = {
  barber: {},
};

export default BarberAvatar;
